import React, { useContext, useState, useEffect } from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  Grid,
  Dialog,
  DialogContent,
  DialogActions,
} from '@material-ui/core';

import { Button } from '../../../components/ui/forms/Button';
import { OrderContext } from '../../../contexts/OrderContext';
import { PatronContext } from '../../../contexts/PatronContext';

export const Filter = ({
  isOpen,
  close,
  filteredPatrons,
  setFilteredPatrons,
}) => {
  const { addPatronsToOrder } = useContext(OrderContext);
  const { patrons } = useContext(PatronContext);

  const [yearGroup, setYearGroup] = useState(7);

  const filterYearGroup = (patron) => {
    return patron.yearGroup === yearGroup;
  };

  useEffect(() => {
    if (yearGroup) setFilteredPatrons(patrons.filter(filterYearGroup));
    //eslint-disable-next-line
  }, [yearGroup]);

  return (
    <Dialog open={isOpen} onClose={close}>
      <DialogContent>
        <FormControl>
          <Select
            name='yearGroup'
            value={yearGroup}
            onChange={(e) => {
              const year = parseInt(e.target.value);
              setYearGroup(year);
            }}
          >
            <MenuItem value={1}>Year 1</MenuItem>
            <MenuItem value={2}>Year 2</MenuItem>
            <MenuItem value={3}>Year 3</MenuItem>
            <MenuItem value={4}>Year 4</MenuItem>
            <MenuItem value={5}>Year 5</MenuItem>
            <MenuItem value={6}>Year 6</MenuItem>
            <MenuItem value={7}>Year 7</MenuItem>
            <MenuItem value={8}>Year 8</MenuItem>
            <MenuItem value={9}>Year 9</MenuItem>
            <MenuItem value={10}>Year 10</MenuItem>
            <MenuItem value={11}>Year 11</MenuItem>
            <MenuItem value={12}>Year 12</MenuItem>
          </Select>
        </FormControl>
        <Grid container>
          <Grid item md={12}>
            <Button
              colour='success'
              variant='contained'
              onClick={() => {
                setFilteredPatrons(patrons.filter(filterYearGroup));
                addPatronsToOrder(filteredPatrons);
                close();
              }}
            >
              Order for all of year {yearGroup}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setFilteredPatrons(patrons);
            close();
          }}
        >
          Clear
        </Button>
        <Button
          colour='secondary'
          onClick={() => {
            setFilteredPatrons(patrons.filter(filterYearGroup));
            close();
          }}
        >
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};
